import { Injectable, EventEmitter, Inject } from '@angular/core';
import { Router } from '@angular/router';
import {ApiService, FeatureService, HTTP_CLIENT} from '@netfoundry-ui/shared/services';
import { EdgeRouterServiceV2 } from '@netfoundry-ui/shared/apiv2';
import { ExtensionService, GrowlerModel, GrowlerService, DataTableFilterService, FilterObj, DEFAULT_APP_CONFIG } from 'ziti-console-lib';
import { cloneDeep } from 'lodash';
import { MatDialog } from '@angular/material/dialog';
import {MetricsModalComponent} from "@netfoundry-ui/feature/metrics-modal";
import {DialLogsTimelineDrawerService} from "@netfoundry-ui/feature/dial-logs-timeline";
import {EventsModalComponent} from "@netfoundry-ui/feature/events-modal";
import {isEmpty} from "lodash";
import {BehaviorSubject, firstValueFrom, Observable} from "rxjs";
import {ZitiShareService} from "@netfoundry-ui/feature/ziti/ziti-share";
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {Environment, ENVIRONMENT} from "@netfoundry-ui/shared/model";

// Row-menu icons for the list actions: the list-table renders a menu item's `icon` (SVG markup) in
// currentColor. (The legacy ag-grid page treats `icon` as a CSS class and ignores SVG — harmless.)
const ROW_ICON_EVENTS = '<svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M8 2.4a3.2 3.2 0 0 0-3.2 3.2c0 2.3-.7 3.4-1.2 4-.2.2 0 .5.3.5h8.2c.3 0 .5-.3.3-.5-.5-.6-1.2-1.7-1.2-4A3.2 3.2 0 0 0 8 2.4z"/><path d="M6.7 12.3a1.4 1.4 0 0 0 2.6 0"/></svg>';
const ROW_ICON_METRICS = '<svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M3 13V8.5M8 13V3.5M13 13V6.5"/></svg>';
const ROW_ICON_DIAL_LOGS = '<svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><path d="M6 4h7.5M6 8h7.5M6 12h7.5"/><circle cx="3" cy="4" r="1" fill="currentColor" stroke="none"/><circle cx="3" cy="8" r="1" fill="currentColor" stroke="none"/><circle cx="3" cy="12" r="1" fill="currentColor" stroke="none"/></svg>';
const ROW_ICON_SHARE = '<svg viewBox="0 0 16 16" width="15" height="15" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><circle cx="11.5" cy="3.5" r="1.8"/><circle cx="4" cy="8" r="1.8"/><circle cx="11.5" cy="12.5" r="1.8"/><path d="M5.6 7.1 9.9 4.4M5.6 8.9l4.3 2.7"/></svg>';

@Injectable({ providedIn: 'root' })
export class IdentitiesExtensionService implements ExtensionService {

  hosting = false;
  errors: any = {};
  closed: any = new EventEmitter<any>();
  consoleActionTriggered: any = new EventEmitter<any>();
  extensionEvent: EventEmitter<any> = new EventEmitter<any>();
  currentNetwork: any = {};
  dialogRef: any;

  formDataChanged: any = new BehaviorSubject<any>({isEmpty: true});
  closeAfterSave = true;

  useDeleteSplitButton = true;

  moreActions = [];

  listActions = [
    {name: 'Show Events', action: 'show-events', label: 'Show Events', icon: ROW_ICON_EVENTS, callback: this.showEventsModal.bind(this)},
    {name: 'Show Metrics', action: 'show-metrics', label: 'Show Metrics', icon: ROW_ICON_METRICS, callback: this.showMetricsModal.bind(this)},
    {name: 'Show Dial Logs', action: 'show-dial-logs', label: 'Show Dial Logs', icon: ROW_ICON_DIAL_LOGS, callback: this.showDialLogsModalFromListPage.bind(this)},
    {name: 'Share', action: 'share', label: 'Share', icon: ROW_ICON_SHARE, callback: this.shareRegistration.bind(this), hidden: this.hideShareRegistration.bind(this)},
  ]

  formData: any = {};
  // Current page's ordered rows (server-sorted/filtered), for drawer prev/next.
  private tableRows: any[] = [];

  isAdminColumnFilterActive = false;

  conflictDetails: any = {};
  conflictPageData: any = null;

  constructor(
    private edgeRouterService: EdgeRouterServiceV2,
    private apiService: ApiService,
    private growlerService: GrowlerService,
    private dialogForm: MatDialog,
    protected filterService: DataTableFilterService,
    private zitiShareService: ZitiShareService,
    private featureService: FeatureService,
    @Inject(ENVIRONMENT) private environment: Environment,
    @Inject(HTTP_CLIENT) private http: HttpClient,
    private router: Router,
    private dialLogsDrawer: DialLogsTimelineDrawerService,
  ) {
    this.apiService.currentNetwork.subscribe((network) => {
      this.currentNetwork = network;
    });
    this.consoleActionTriggered.subscribe(({ action, page, item, type }: any) => {
      if (action === 'edit' || !(window as any)?.gtag || !page) {
        return;
      }
      (window as any).gtag('event', `${action}_${page}`, {
        [`${page}_name`]: item?.name,
        [`${page}_id`]: item?.id,
      });
    });
    this.filterService.filtersChanged.subscribe((event: any) => {
      this.isAdminColumnFilterActive = false;
      this.filterService.filters.forEach((filter: any) => {
        if (filter.columnId === 'isAdmin') {
          this.isAdminColumnFilterActive = filter.hidden !== true;
        }
      });
    });
  }

  extendOnInit() {
    //this.initAdminFilter();
  }

  hideEventsAction() {
    return isEmpty(this.formData?.id);
  }

  hideMetricsAction() {
    return isEmpty(this.formData?.id);
  }

  hideDialLogsAction() {
    return isEmpty(this.formData?.id);
  }

  openVisualizerTab(item: any) {
    this.router.navigate(['/identities', item?.id, 'visualizer']);
  }

  shareRegistration(identity: any) {
    const data: any = {type: 'endpoint', endpoint: identity, networkId: this.currentNetwork?.id};
    this.zitiShareService.show(data);
  }

  hasEnrollmentJwt(identity: any) {
    return !isEmpty(identity?.enrollment?.ott?.token);
  }

  hideShareRegistration(data: any) {
    return !this.hasEnrollmentJwt(data);
  }

  updateFormData(data: any) {
    this.formData = data;
    this.extensionEvent.emit({
      type: 'formDataUpdated',
      data: {
        entityType: 'identity',
        formData: this.formData,
      },
    });
  }

  showMetricsModal(data: any) {
    this.dialogForm.open(MetricsModalComponent, {
      data: {
        resourceType: 'endpoint',
        model: data || this.formData,
        networkGroupId: this.currentNetwork.networkGroupId,
        networkId: this.currentNetwork.id,
      },
      height: '800px',
      width: '1200px',
      autoFocus: false,
    });
  }

  showDialLogsModal(siblings: { id: string; name?: string }[] = []) {
    this.dialLogsDrawer.open(
      {
        resourceType: 'endpoint',
        model: this.formData,
        networkGroupId: this.currentNetwork.networkGroupId,
        networkId: this.currentNetwork.id,
      },
      siblings
    );
  }

  showEventsModal() {
    this.dialogForm.open(EventsModalComponent, {
      data: {
        resourceType: 'endpoint',
        model: this.formData,
        networkId: this.currentNetwork.id,
        networkGroupId: this.currentNetwork.networkGroupId,
      },
      height: '620px',
      width: '1050px',
      autoFocus: false,
    });
  }

  showDialLogsModalFromListPage(zitiIdentity: any) {
    this.formData = zitiIdentity;
    const siblings = this.tableRows
      .filter((r) => r?.id)
      .map((r) => ({ id: r.id, name: r.name }));
    this.showDialLogsModal(siblings);
  }
  extendAfterViewInits(extentionPoints: any): void {}

  initAdminFilter() {
    const filterObj: FilterObj = {
      filterName: 'Admins',
      columnId: 'isAdmin',
      value: false,
      label: 'Non-Admins',
      type: 'BOOLEAN',
    };
    this.filterService.filters = [filterObj];
    this.filterService.filtersChanged.next(this.filterService.filters);
  }

  updateAdminFilter(showAdmin: any) {
    if (showAdmin) {
      this.filterService.filters = this.filterService.filters.filter((filter: any) => {
        return filter.columnId !== 'isAdmin';
      });
    } else {
      const filterObj: FilterObj = {
        filterName: 'Admins',
        columnId: 'isAdmin',
        value: false,
        label: 'Admins',
        type: 'BOOLEAN',
      };
      this.filterService.filters.push(filterObj);
    }
    this.filterService.filtersChanged.next(this.filterService.filters);
  }

  validateData(): Promise<any> {
    return Promise.resolve(true);
  }

  async emitEvent<TData, TResult>(event: any): Promise<TResult | undefined> {
    if (event?.type === 'tableDataUpdated' && event?.data?.resourceType === 'identities') {
      return await this.processIdentityTableData(event.data.results) as TResult;
    }

    this.extensionEvent.emit(event);
    return undefined;
  }

  formDataSaved(data: any): Promise<any> {
    return Promise.resolve(data);
  }

  // Conflict warning icon when the row is flagged conflicted (set by processIdentityTableData).
  private getNamePrefix = (item: any) =>
    item?.conflicted
      ? {
            show: true,
            iconClass: 'icon-Network-Failure',
            tooltip: 'Potential Conflict Detected',
        }
      : { show: false };

  // Shared "Managed By" cell: SCIM icon vs NF loading indicator based on the identity's tags.
  private managedByRenderer = (row: any) => {
            let span = "<span></span>";
            if (row?.data?.tags) {
                if (row?.data?.tags['scimIntegrationId']) span = `<div class="icon icon-SCIM" style="color: var(--primary); font-size:1.75rem; font-family: icomoon!important"></div>`;
                else if (row?.data?.tags['nf-identity-id']) span = `<span class="os" style="background-image: url(/assets/svgs/nf-loading-indicator.svg)"></span>`;
            }

            return `<div class="col desktop" style="overflow: unset; width: 100%; text-align: center">
                ${span}
              </div>`
        }

  processTableColumns(tableColumns: any): any[] {
    // The ListTable passes declarative ListColumn defs; the legacy ag-grid table passes ColDefs.
    // Emit the Managed By column in whichever shape the caller uses (else it renders [object Object]).
    if (tableColumns?.[0]?.key !== undefined) {
      return this.processListTableColumns(tableColumns);
    }

    const updatedTableCols = [];
    updatedTableCols[0] = {
      ...tableColumns[0],
      cellRendererParams: {
        ...(tableColumns[0]?.cellRendererParams || {}),
        getNamePrefix: this.getNamePrefix,
      },
    };

    /*
    TODO - revisit this at a later date
    filtering won't work with existing methods NF managed identities have a nf-identity-id tag while SCIM Managed identities have a scimIntegrationId tag
    filtering currently uses the columnId set in the column definition, I'm unsure if this can be changed by an individual filter
    for these, we ideally want to filter on tags.nf-identity-id != null and tags.scimIntegrationId != null
    while we can somewhat get around this with the use of the verb property, it wraps the value in a string, which does not work
    we likely need to add a specific filter for tags, like we have for attributes
    const mangedByParams = {
            filterType: 'SELECT',
            filterOptions: [
                { label: 'All', value: ''},
                { label: 'SCIM', colId: 'tags.ScimIntegrationId'},
                { label: 'NF', value: 'null'},

            ],
            verb: '!='

        };
    */
    updatedTableCols.push({
        colId: 'tags',
        width: 125,
        minWidth: 100,
        field: 'tags',
        sortable: false,
        headerName: 'Managed By',
        // hacky but seems to work. TableColumnDefaultComponent is not exported by ziti-console-lib but is needed to make the hide and pin features work
        // the first column definition is Name, which simply uses TableColumnDefaultComponent. we can reference it here to get those header components working for the new column
        headerComponent: updatedTableCols[0]?.headerComponent,
        cellRenderer: this.managedByRenderer,
        resizable: true,
        cellClass: 'nf-cell-vert-align tCol',
        hide: true,


    });

    for(let i = 1; i< tableColumns.length; i++) {
      updatedTableCols.push(tableColumns[i]);
    }
    return updatedTableCols;
  }

  // ListTable variant: carry the conflict prefix through the Name cell config, then append the
  // Managed By column (hidden by default) after Name.
  // Public to satisfy the ExtensionService.processListTableColumns hook (ziti-console-lib 1.5.5+).
  processListTableColumns(tableColumns: any[]): any[] {
    const columns = [...tableColumns];
    const nameCol = columns[0];
    if (nameCol) {
      const baseCellInputs = nameCol.cellInputs;
      columns[0] = {
        ...nameCol,
        cellInputs: (ctx: any) => {
          const inputs = typeof baseCellInputs === 'function' ? baseCellInputs(ctx) : baseCellInputs || {};
          return {
            ...inputs,
            cellConfig: {
              ...(inputs.cellConfig || {}),
              getNamePrefix: this.getNamePrefix,
            },
          };
        },
      };
    }
    columns.splice(1, 0, {
      key: 'managedBy',
      field: 'tags',
      label: 'Managed By',
      cellHtml: this.managedByRenderer,
      width: 125,
      minWidth: 100,
      sortable: false,
      resizable: true,
      cellClass: 'nf-cell-vert-align lt-cell-center',
      hidden: true,
    });
    return columns;
  }

  private async processIdentityTableData(results: any): Promise<any> {
    // Cache the current page's ordered rows so the dial-logs drawer can page prev/next.
    if (Array.isArray(results?.data)) {
      this.tableRows = results.data;
    }
    if (!this.currentNetwork?.id || !Array.isArray(results?.data) || results.data.length === 0) {
      return results;
    }

    const identityIds = results.data
      .map((row: any) => row?.id)
      .filter((id: string) => !isEmpty(id));

    if (!identityIds.length) {
      return results;
    }

    const conflictMap = new Map<string, boolean>();
    const chunkSize = 30;
    const requests: Promise<any>[] = [];

    for (let index = 0; index < identityIds.length; index += chunkSize) {
      requests.push(firstValueFrom(this.getIdentityConflicts(this.currentNetwork.id, identityIds.slice(index, index + chunkSize))));
    }

    try {
      const responses = await Promise.all(requests);
      responses.forEach((response: any) => {
        const conflictList = response?._embedded?.identityConflictList || [];
        conflictList.forEach((conflict: any) => {
          if (!conflict?.identityId) {
            return;
          }
          conflictMap.set(conflict.identityId, !!conflict.conflicted);
        });
      });
    } catch (error) {
      results.data = results.data.map((row: any) => ({
        ...row,
        conflicted: false,
      }));
      return results;
    }

    results.data = results.data.map((row: any) => ({
      ...row,
      conflicted: conflictMap.get(row?.id) || false,
    }));

    return results;
  }

  getIdentityConflicts(networkId: string, zitiIds: string[]): Observable<any> {
    const headers = new HttpHeaders().set('Accept', 'application/json');
    const params = new HttpParams()
      .set('networkId', networkId)
      .set('identityId', zitiIds.join(','));
    const protocol = this.environment.protocol || 'https';
    const url = `${protocol}://${this.environment.gatewayUrl}/conflict-detection/identity-conflicts`;
    return this.http.get(url, {
      headers: headers,
      params: params,
      responseType: 'json',
    });
  }

  getIdentityAttributeConflict(networkId: string, roleAttributes: string[], identityId?: string): Observable<any> {
    const headers = new HttpHeaders().set('Accept', 'application/json');
    const attributeValue = (roleAttributes || [])
      .filter((attribute: string) => !isEmpty(attribute))
      .map((attribute: string) => {
        const trimmedAttribute = attribute.trim();
        if (trimmedAttribute.startsWith('#') || trimmedAttribute.startsWith('@')) {
          return trimmedAttribute;
        }
        return `#${trimmedAttribute}`;
      })
      .join(',');
    const params = new HttpParams()
      .set('networkId', networkId)
      .set('attribute', attributeValue)
      .set('identityId', identityId || '');

    const protocol = this.environment.protocol || 'https';
    const url = `${protocol}://${this.environment.gatewayUrl}/conflict-detection/identity-conflict-precheck`;
    return this.http.get(url, {
      headers: headers,
      params: params,
      responseType: 'json',
    });
  }

  getConflictDetails(networkId: string, identityId?: string, roleAttributes: string[] = []): Observable<any>  {
    const headers = new HttpHeaders().set('Accept', 'application/json');
    const attributeValue = (roleAttributes || [])
      .filter((attribute: string) => !isEmpty(attribute))
      .map((attribute: string) => {
        const trimmedAttribute = attribute.trim();
        if (trimmedAttribute.startsWith('#') || trimmedAttribute.startsWith('@')) {
          return trimmedAttribute;
        }
        return `#${trimmedAttribute}`;
      })
      .join(',');
    let params = new HttpParams().set('networkId', networkId);

    if (identityId) {
      params = params.set('identityId', identityId);
    } else {
      params = params.set('attribute', attributeValue);
    }

    const protocol = this.environment.protocol || 'https';
    const url = `${protocol}://${this.environment.gatewayUrl}/conflict-detection/identity-conflict-details`;
    return this.http.get(url, {
      headers: headers,
      params: params,
      responseType: 'json',
    });
  }

  get showApiCalls(): boolean {
    return this.featureService.powerUserEnabled;
  }
}
